/**
 * 定义全局filter
 */
import Day from "dayjs";
/**
 * @description 计算星期
 *
 * @param {*} date
 * @returns
 */
export function formatWeekDate(date) {
  if (!date) return "";
  const weeksList = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  return weeksList[Day(date).day()];
}

/**
 * @description 计算星期
 *
 * @param {*} date
 * @returns
 */
export function formatIDCard(num) {
  let tmp = num.toString();
  return `${tmp.slice(0, 4)}********${tmp.slice(-4)}`;
}
export function filterRate(val) {
  return val === "-" ? "-" : (Math.abs(Number(val)) * 100).toFixed(1) + "%";
}
export function filterDateText(val) {
    return val.split('-')[0].split('.')[1] + '.' +  val.split('-')[0].split('.')[2] + '-' + val.split('-')[1].split('.')[1] + '.' + val.split('-')[1].split('.')[2]
}
export function filterToFixed2(val) {
    return val === "-" ? "-" : Number(val).toFixed(2);
  }
export default {
  formatIDCard,
  formatWeekDate,
  filterRate,
  filterDateText,
  filterToFixed2
};



// WEBPACK FOOTER //
// ./src/utils/filters.js